import React from "react";
import { Check, Close, Undo } from "@mui/icons-material";
import { IconButton } from "@mui/material";
import { ICellRendererParams } from "ag-grid-community";

import { ExtendedPermission, PermissionLevel } from "fond/types";
import { allowRemoval, isNew, isNewInheritOverride } from "fond/utils/permissions";

interface IActionCellRendererParams extends ICellRendererParams<ExtendedPermission> {
  update: (index: number, value: ExtendedPermission) => void;
  remove: (index: number) => ExtendedPermission;
  values: ExtendedPermission[];
  currentUsername: string;
  currentPermission: PermissionLevel;
}

const ActionCellRenderer: React.FC<IActionCellRendererParams> = ({
  data: permission,
  node,
  update,
  remove,
  values,
  currentUsername,
  currentPermission,
}) => {
  const rowIndex = node.sourceRowIndex;

  const handleOnUndo = () => {
    update(rowIndex, {
      ...values[rowIndex],
      Remove: false,
    });
  };

  const handleOnDelete = () => {
    if (permission) {
      if (!permission.Inherited) {
        if (!permission.New) {
          // We don't remove existing permissions - we instead flag it for removal
          update(rowIndex, {
            ...values[rowIndex],
            Remove: true,
          });
        } else {
          remove(rowIndex);
        }
      } else {
        update(rowIndex, {
          ...values[rowIndex],
          Level: "inherited",
          Revert: !values[rowIndex].ReadOnly,
        });
      }
    }
  };

  if (!permission) return null;

  if (permission.Remove) {
    return (
      <IconButton size="small" className="undo-button" name="undo" onClick={handleOnUndo} data-testid="undo-delete-share-permission">
        <Undo />
      </IconButton>
    );
  }

  if (permission?.Submitted) {
    return <Check />;
  }

  if (isNew(permission) || isNewInheritOverride(permission) || allowRemoval(permission, currentUsername, currentPermission)) {
    return (
      <IconButton size="small" className="delete-button" name="delete" onClick={handleOnDelete} data-testid="delete-share-permission">
        <Close />
      </IconButton>
    );
  }
  return <div />;
};

export default ActionCellRenderer;
